export default "__VITE_ASSET__582dae6a__"